import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from 'lucide-react'
import { memo, type ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

import type { DataTableColumnHeaderProps } from './data-table.interface'

const DataTableColumnHeaderBase: React.FC<DataTableColumnHeaderProps> = ({
  title,
  isSortable = false,
  sortOrder = null,
  onSort,
  align = 'left',
  className,
}): ReactNode => {
  const alignmentClassMap = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
  }

  if (!isSortable) {
    return (
      <div
        className={cn(
          'data-table-column-header flex items-center',
          alignmentClassMap[align],
          className
        )}
      >
        {title}
      </div>
    )
  }

  const SortIcon =
    sortOrder === 'asc' ? ArrowUpIcon : sortOrder === 'desc' ? ArrowDownIcon : ArrowUpDownIcon

  return (
    <div
      className={cn(
        'data-table-column-header flex items-center',
        alignmentClassMap[align],
        className
      )}
    >
      <Button
        variant="ghost"
        size="sm"
        className="data-table-column-sort -ml-3 h-8 data-[state=open]:bg-accent"
        onClick={onSort}
      >
        <span>{title}</span>
        <SortIcon className="ml-2 size-4" />
      </Button>
    </div>
  )
}

export const DataTableColumnHeader = memo(DataTableColumnHeaderBase)

DataTableColumnHeader.displayName = 'DataTableColumnHeader'
